<template>
  <div
    class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6"
  >
    <div class="hidden sm:block">
      <p class="text-sm leading-5 text-gray-700" v-if="meta">
        Mostrando
        <span class="font-medium"><b>{{ meta.from }}</b></span>
        a
        <span class="font-medium" v-if="meta"><b>{{ meta.to }}</b></span>
        de
        <span class="font-medium" v-if="meta"><b>{{ meta.total }}</b></span>
        resultados. Filas por páginas:
        <select
          v-model="perPage"
          @change="reloadPerPage"
          class="inline-flex px-1 py-1 ml-1 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-400 rounded-md hover:text-gray-800 hover:border-gray-800 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-100 active:text-gray-700">
          <option>5</option>
          <option>10</option>
          <option>20</option>
        </select>
      </p>
    </div>
    <div class="flex justify-between flex-1 sm:justify-end" v-if="links">
     <a
        v-if="links.first && meta.current_page > 1"
        @click="first"
        href="#"
        class="inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-400 rounded-md hover:text-gray-800 hover:border-gray-800 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-100 active:text-gray-700"
      >
        Primera
      </a>
      <a
        v-if="links.prev"
        @click="prev"
        href="#"
        class="inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-400 rounded-md hover:text-gray-800 hover:border-gray-800 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-100 active:text-gray-700"
      >
        <<
      </a>
      <a
        v-if="links.next"
        @click="next"
        href="#"
        class="inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-400 rounded-md hover:text-gray-800 hover:border-gray-800 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-100 active:text-gray-700"
      >
        >>
      </a>
      <a
        v-if="links.last && meta.current_page != meta.last_page"
        @click="last"
        href="#"
        class="inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-400 rounded-md hover:text-gray-800 hover:border-gray-800 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 active:bg-gray-100 active:text-gray-700"
      >
        Última
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['meta', 'links'],

  data() {
    return {
      perPage: 10,
    }
  },

  methods: {
    reloadPerPage() {
      const paginate = {
        page: 1,
        perPage: this.perPage
      }
      this.$emit('data-paginate', paginate)
    },
    first(){
      const paginate = {
        page: 1,
        perPage: this.perPage
      }
      this.$emit('data-paginate', paginate)
    },
    prev(){
      const paginate = {
        page: this.meta.current_page - 1,
        perPage: this.perPage
      }
      this.$emit('data-paginate', paginate)
    },
    next(){
      const paginate = {
        page: this.meta.current_page + 1,
        perPage: this.perPage
      }
      this.$emit('data-paginate', paginate)
    },
    last(){
      const paginate = {
        page: this.meta.last_page,
        perPage: this.perPage
      }
      this.$emit('data-paginate', paginate)
    }
  }
}
</script>
